import { rowColumn } from "../../../components/table/Table";
export const providerListTable = (currPath: string): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "KIS Provider",
    column: "providerBase.providerDetails.providerName",
    type: "string",
    allowSort: true,
    sortOn: "ProviderBase.ProviderDetails.ProviderName",
  },
  {
    label: "Region",
    column: "providerBase.providerDetails.region",
    type: "string",
    allowSort: true,
    sortOn: "ProviderBase.ProviderDetails.Region",
  },
  {
    label: "Area",
    column: "providerBase.providerDetails.area",
    type: "string",
    allowSort: true,
    sortOn: "ProviderBase.ProviderDetails.Area",
  },
  {
    label: "KIS Provider email 1",
    column: "providerBase.providerDetails.providerEmail1",
    type: "string",
    allowSort: true,
    sortOn: "ProviderBase.ProviderDetails.ProviderEmail1",
  },
  {
    label: "Actions",

    body: (rowData) => <a href={`${currPath}/${rowData.id}`}>View Details</a>,
  },
];
